import { WhatsNewModal } from './WhatsNewModal';
import carouselImage from './channel-carousel-upgrade.png';

type ChannelCarouselUpgradeModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ChannelCarouselUpgradeModal = (
  p: ChannelCarouselUpgradeModalProps,
) => (
  <WhatsNewModal
    {...p}
    tag="New section here!"
    title="Offer carousel section"
    description="Promote your offers using offer carousel component"
    imageSrc={carouselImage}
  />
);
